module.exports = __webpack_public_path__ + "static/js/0.4a4f6103.chunk.worker.js"